// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b7c7ae83","638":"7da7de7f","876":"162da7fd"}[chunkId] + ".chunk.js";
};